import 'css-chunksrc/feature/notification/AuthRequestToastNotification.module.scss';export default {
  "root": "AuthRequestToastNotification_root"
};